import React, { Component } from 'react'
//import '../../css/App.css';

class Palette extends Component {

  render() {
    return (
        <div className="mt-10 h-full">
            <h3 className="font-bold">Palette</h3>
            <div className="bg-no-repeat h-full relative max-w-full" style={{backgroundImage: "url('images/palette.png')", width: 600, height: 650}}>
                { 
                    this.props.palette.map((color, index) => {
                        let position = [0, 0];
                        switch(index) {
                            case 0:
                            default:
                                position = [150, 100];
                                break;
                            case 1:
                                position = [100, 200];
                                break;
                            case 2:
                                position = [90, 320];
                                break;
                            case 3:
                                position = [130, 430];
                                break;
                            case 4:
                                position = [225, 500];
                                break;
                        }
                        return (
                            <div className="pigment cursor-dropper shadow rounded-full h-20 w-20 absolute" key={index} onClick={(event) => this.props.handleClick(event, color)} 
                                style={
                                    {
                                        backgroundColor: color,
                                        top: position[1],
                                        left: position[0]
                                    }
                                }>
                                <button type="button" aria-label="Remove" class="remove-pigment right-0 absolute z-10 bg-white rounded-full text-red-600 hover:text-red-700 focus:outline-none focus:text-red-700 transition ease-in-out duration-150 shadow h-6 w-6" onClick={() => this.props.removePigment(index)}>
                                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="mx-auto h-4 w-4">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                    </svg>
                                </button>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
  }
}

export default Palette;
